var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1567 3.77637C9.76461 3.77637 3.75049 9.426 3.75049 16.3701C3.75049 23.3142 9.76461 28.9639 17.1567 28.9639C24.5489 28.9639 30.563 23.3142 30.563 16.3701C30.563 9.426 24.5489 3.77637 17.1567 3.77637ZM13.9199 10.8495C14.7365 10.0363 15.8857 9.58887 17.1567 9.58887C18.4278 9.58887 19.5666 10.0393 20.3865 10.8567C21.2173 11.685 21.6214 12.7979 21.526 13.9943C21.3352 16.3701 19.3759 18.3076 17.1567 18.3076C14.9376 18.3076 12.9744 16.3701 12.7875 13.9937C12.6927 12.7876 13.0962 11.6711 13.9199 10.8495ZM17.1567 27.0264C15.6424 27.0273 14.1433 26.7426 12.7482 26.1891C11.3532 25.6355 10.0907 24.8245 9.03564 23.8041C9.63993 22.9945 10.4099 22.3062 11.3005 21.7794C12.9434 20.79 15.0227 20.2451 17.1567 20.2451C19.2908 20.2451 21.37 20.79 23.011 21.7794C23.9024 22.306 24.673 22.9943 25.2778 23.8041C24.2228 24.8246 22.9603 25.6357 21.5653 26.1892C20.1703 26.7428 18.6711 27.0274 17.1567 27.0264V27.0264Z",
    fill: "#2D3748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.9bd354de01b3a3fab0ac50c210b8d4c0.svg";
export { ForwardRef as ReactComponent };